export const objectRemoveNull = (target, defaultTarget) => {
  const object = { ...target };
  for (const property in object) {
    object[property] = object[property] ?? defaultTarget[property];
  }
  return object;
};
